export default {
  all: () => ['users'],
  // membersOnly changes the response, so it must be in the key — otherwise the roster and
  // the person pickers share a cache entry.
  index: (page: number, membersOnly = false) => ['users', { page, membersOnly }],
  currentUser: () => ['users', 'current'],
}
